module.exports = __webpack_public_path__ + "static/media/bad_weather.80d0b35e.svg";